export function handleKeydown(
    event: React.KeyboardEvent<HTMLTextAreaElement>,
    callback : ()=> void
) {
    if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        callback();
        // submitRequest();
    }

}


export function handleKeydown_esc(
    event: React.KeyboardEvent<HTMLTextAreaElement>,
    callback : ()=> void
) {
    if (event.key === "Escape") {
        event.preventDefault();
        callback();
        // submitRequest();
    }
    
}